import WorksiteCollection from './WorksiteCollection';

export default class ActiveWorksiteCollection extends WorksiteCollection
{

    itemShouldBeInCollection(worksite)
    {
        return worksite.archived_at == null;
    }

}